var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topQuantity',{staticStyle:{"margin-bottom":"20px"}}),_c('div',{staticClass:"components-row"},[_c('leftPipeDiameter'),_c('middleRemote'),_c('rightValve')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }